module.exports = __webpack_public_path__ + "img/TPV-L1-5-Pagina6 A.22e748bd.png";